export default function formatArabicDate(isoDate) {
    try {
        const date = new Date(isoDate);

        // Check if date is valid
        if (isNaN(date.getTime())) {
            return 'تاريخ غير محدد';
        }

        const options = {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        };

        return new Intl.DateTimeFormat('ar-EG', options).format(date);
    } catch (error) {
        return 'تاريخ غير محدد';
    }
}